import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, SimpleGrid, Box, Icon, Text } from '@chakra-ui/react';
import { FT_SRP_DYNAMIC_FILTERS } from '@whitbread-eos/api';
import { Button, Location as MapPinIcon, Filter as HorizontalFilter, Dismiss, Icon as IconComponent } from '@whitbread-eos/atoms';
import { useScreenSize, useMobileControlsDisplay, useFeatureToggle, useSemanticTypography } from '@whitbread-eos/utils';
import { List as ListIcon } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import { useState, createElement as _createElement } from 'react';
import { DestinationFilters } from '../../destination';
import Filters from '../Filters';
import SortBy from '../SortBy';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var VIEW_TYPE_CONSTANTS = {
  mapView: '1',
  listView: '2'
};
export function ControlsDisplaySection(_ref) {
  var viewType = _ref.viewType,
    onChangeViewType = _ref.onChangeViewType,
    onChangeSortValue = _ref.onChangeSortValue,
    onChangeFilters = _ref.onChangeFilters,
    buttonLabels = _ref.buttonLabels,
    filterByLabels = _ref.filterByLabels,
    sortByLabels = _ref.sortByLabels,
    defaultFilters = _ref.defaultFilters,
    sortValue = _ref.sortValue,
    visibility = _ref.visibility,
    isPiSortOrderDropdownEnabled = _ref.isPiSortOrderDropdownEnabled,
    isBbSortOrderDropdownEnabled = _ref.isBbSortOrderDropdownEnabled,
    hideViewToggle = _ref.hideViewToggle,
    showDynamicFilters = _ref.showDynamicFilters,
    dynamicFilters = _ref.dynamicFilters,
    selectedFilters = _ref.selectedFilters,
    _setSelectedFilters = _ref.setSelectedFilters,
    clearAllLabel = _ref.clearAllLabel;
  var getTypographyProps = useSemanticTypography();
  var genericSecondaryLegacyTypography = {};
  var genericSecondarySemanticTypography = {
    textStyle: 'body-m-regular'
  };
  var genericSecondaryTypography = getTypographyProps(genericSecondaryLegacyTypography, genericSecondarySemanticTypography);
  var computedSharedButtonProps = _objectSpread(_objectSpread({}, sharedButtonPropsLayout), getTypographyProps(sharedButtonLegacyTypography, sharedButtonSemanticTypography));
  var isSortVisible = viewType === VIEW_TYPE_CONSTANTS.listView;
  return _jsxs(SimpleGrid, _objectSpread(_objectSpread({}, getControlsGridStyles(isSortVisible, !hideViewToggle)), {}, {
    children: [_jsx(Box, {
      sx: fullWidthChild,
      children: showDynamicFilters && dynamicFilters ? _jsx(Box, {
        mr: {
          base: 'md',
          lg: 'lg'
        },
        children: _jsx(DestinationFilters, {
          selectedFilters: selectedFilters,
          setSelectedFilters: selectedFilters => {
            _setSelectedFilters(selectedFilters);
            var filters = selectedFilters.reduce((prev, curr) => {
              var _curr$codes;
              return [...prev, ...((_curr$codes = curr.codes) !== null && _curr$codes !== void 0 ? _curr$codes : [])];
            }, []);
            onChangeFilters(filters);
          },
          labels: dynamicFilters,
          showClearFilters: false,
          leftIcon: _jsx(Icon, _objectSpread(_objectSpread({
            as: HorizontalFilter
          }, filterIconStyles), {}, {
            viewBox: "0 0 16 16"
          })),
          buttonProps: computedSharedButtonProps
        })
      }) : _jsx(Filters, {
        onChangeFilters: onChangeFilters,
        defaultFilters: defaultFilters,
        isDisabled: !!(visibility !== null && visibility !== void 0 && visibility.isFilterDisabled),
        labels: filterByLabels,
        leftIcon: _jsx(Icon, _objectSpread(_objectSpread({
          as: HorizontalFilter
        }, filterIconStyles), {}, {
          viewBox: "0 0 16 16"
        })),
        buttonProps: computedSharedButtonProps
      })
    }), isSortVisible && _jsx(Box, {
      sx: fullWidthChild,
      children: _jsx(SortBy, {
        labels: sortByLabels,
        selectedOption: sortValue,
        isDisabled: !!(visibility !== null && visibility !== void 0 && visibility.isSortDisabled),
        onChange: onChangeSortValue,
        isPiSortOrderDropdownEnabled: isPiSortOrderDropdownEnabled,
        isBbSortOrderDropdownEnabled: isBbSortOrderDropdownEnabled,
        buttonProps: computedSharedButtonProps
      })
    }), !hideViewToggle && _jsx(Box, {
      sx: fullWidthChild,
      children: _jsx(Button, _objectSpread(_objectSpread(_objectSpread({
        "data-testid": "controls-map-or-list-button"
      }, mapListButtonStyles), genericSecondaryTypography), {}, {
        onClick: onChangeViewType,
        leftIcon: viewType === VIEW_TYPE_CONSTANTS.listView ? _jsx(Icon, _objectSpread({
          as: MapPinIcon
        }, mapIconStyles)) : _jsx(Icon, _objectSpread({
          as: ListIcon
        }, listIconStyles)),
        children: _jsx(Text, _objectSpread(_objectSpread({
          as: "span"
        }, genericSecondaryTypography), {}, {
          children: viewType === VIEW_TYPE_CONSTANTS.listView ? buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.map : buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.list
        }))
      }))
    }), renderSelectedDynamicFilters(!!showDynamicFilters, selectedFilters, viewType, _setSelectedFilters, onChangeFilters, clearAllLabel)]
  }));
}
export default function Controls(_ref2) {
  var _buttonLabels$recomme, _buttonLabels$distanc, _buttonLabels$price, _buttonLabels$filters;
  var viewType = _ref2.viewType,
    onChangeViewType = _ref2.onChangeViewType,
    onChangeSortValue = _ref2.onChangeSortValue,
    onChangeFilters = _ref2.onChangeFilters,
    labels = _ref2.labels,
    dynamicFilters = _ref2.dynamicFilters,
    sortValue = _ref2.sortValue,
    defaultFilters = _ref2.defaultFilters,
    visibility = _ref2.visibility,
    _ref2$isPiSortOrderDr = _ref2.isPiSortOrderDropdownEnabled,
    isPiSortOrderDropdownEnabled = _ref2$isPiSortOrderDr === void 0 ? false : _ref2$isPiSortOrderDr,
    _ref2$isBbSortOrderDr = _ref2.isBbSortOrderDropdownEnabled,
    isBbSortOrderDropdownEnabled = _ref2$isBbSortOrderDr === void 0 ? false : _ref2$isBbSortOrderDr,
    channel = _ref2.channel,
    _ref2$hideViewToggle = _ref2.hideViewToggle,
    hideViewToggle = _ref2$hideViewToggle === void 0 ? false : _ref2$hideViewToggle,
    rightContent = _ref2.rightContent,
    _ref2$isSplitView = _ref2.isSplitView,
    isSplitView = _ref2$isSplitView === void 0 ? false : _ref2$isSplitView;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useScreenSize = useScreenSize(),
    isLessThanMd = _useScreenSize.isLessThanMd;
  var buttonLabels = labels.buttonLabels,
    filterLabels = labels.filterLabels;
  var controlsDisplay = useMobileControlsDisplay(channel);
  var _useFeatureToggle = useFeatureToggle(),
    isSrpDynamicFiltersEnabled = _useFeatureToggle[FT_SRP_DYNAMIC_FILTERS];
  var getTypographyProps = useSemanticTypography();
  var genericSecondaryLegacyTypography = {};
  var genericSecondarySemanticTypography = {
    textStyle: 'body-m-regular'
  };
  var genericSecondaryTypography = getTypographyProps(genericSecondaryLegacyTypography, genericSecondarySemanticTypography);
  var showDynamicFilters = isSrpDynamicFiltersEnabled && dynamicFilters && !(visibility !== null && visibility !== void 0 && visibility.isFilterDisabled);
  var sortByLabels = {
    sortByRecommended: (_buttonLabels$recomme = buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.recommended) !== null && _buttonLabels$recomme !== void 0 ? _buttonLabels$recomme : '',
    sortByDistance: (_buttonLabels$distanc = buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.distance) !== null && _buttonLabels$distanc !== void 0 ? _buttonLabels$distanc : '',
    sortByPrice: (_buttonLabels$price = buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.price) !== null && _buttonLabels$price !== void 0 ? _buttonLabels$price : ''
  };
  var filterByLabels = {
    filterByButton: (_buttonLabels$filters = buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.filtersLong) !== null && _buttonLabels$filters !== void 0 ? _buttonLabels$filters : '',
    filters: filterLabels
  };
  var _useState = useState(getSelectedFilters(dynamicFilters, defaultFilters)),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilters = _useState2[0],
    _setSelectedFilters2 = _useState2[1];
  var mapViewStyles = showDynamicFilters ? _objectSpread(_objectSpread({}, mapViewWrapperStyles), {}, {
    position: 'relative',
    ml: horizontalOffset,
    mr: 'auto'
  }) : _objectSpread(_objectSpread({}, mapViewWrapperStyles), {}, {
    position: 'absolute',
    zIndex: 2,
    left: horizontalOffset
  });
  if (controlsDisplay) {
    var _buttonLabels$filter;
    return _jsx(ControlsDisplaySection, {
      viewType: viewType,
      onChangeViewType: onChangeViewType,
      onChangeSortValue: onChangeSortValue,
      onChangeFilters: onChangeFilters,
      filterByLabels: _objectSpread(_objectSpread({}, filterByLabels), {}, {
        filterByButton: (_buttonLabels$filter = buttonLabels === null || buttonLabels === void 0 ? void 0 : buttonLabels.filter) !== null && _buttonLabels$filter !== void 0 ? _buttonLabels$filter : ''
      }),
      buttonLabels: buttonLabels,
      sortByLabels: sortByLabels,
      defaultFilters: defaultFilters,
      sortValue: sortValue,
      visibility: visibility,
      isPiSortOrderDropdownEnabled: true,
      isBbSortOrderDropdownEnabled: true,
      hideViewToggle: hideViewToggle,
      showDynamicFilters: !!showDynamicFilters,
      dynamicFilters: dynamicFilters,
      selectedFilters: selectedFilters,
      setSelectedFilters: _setSelectedFilters2,
      clearAllLabel: t('tableFilter.clearAll')
    });
  }
  return _jsxs(_Fragment, {
    children: [_jsxs(Flex, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, wrapperStyles), isSplitView ? splitViewWrapperStyles : {}), viewType === VIEW_TYPE_CONSTANTS.mapView ? mapViewStyles : {}), {}, {
      mb: showDynamicFilters && selectedFilters.length > 0 ? '0' : 'var(--chakra-space-md)',
      sx: isSplitView ? {
        '& > *': {
          margin: 0
        }
      } : undefined,
      children: [_jsxs(Flex, {
        mb: {
          mobile: 'sm',
          md: '0'
        },
        gap: isSplitView ? 'xlg' : undefined,
        sx: isSplitView ? {
          '& > *': {
            margin: 0
          }
        } : undefined,
        children: [showDynamicFilters ? _jsx(Box, {
          mr: isSplitView ? 0 : {
            base: 'md',
            lg: 'lg'
          },
          children: _jsx(DestinationFilters, {
            selectedFilters: selectedFilters,
            setSelectedFilters: selectedFilters => {
              _setSelectedFilters2(selectedFilters);
              var filters = selectedFilters.reduce((prev, curr) => {
                var _curr$codes2;
                return [...prev, ...((_curr$codes2 = curr.codes) !== null && _curr$codes2 !== void 0 ? _curr$codes2 : [])];
              }, []);
              onChangeFilters(filters);
            },
            labels: dynamicFilters,
            showClearFilters: false
          })
        }) : _jsx(Filters, {
          onChangeFilters: onChangeFilters,
          defaultFilters: defaultFilters,
          isDisabled: visibility === null || visibility === void 0 ? void 0 : visibility.isFilterDisabled,
          labels: filterByLabels,
          buttonProps: genericSecondaryTypography
        }), viewType === VIEW_TYPE_CONSTANTS.listView && _jsx(SortBy, {
          labels: sortByLabels,
          selectedOption: sortValue,
          isDisabled: !!(visibility !== null && visibility !== void 0 && visibility.isSortDisabled),
          onChange: onChangeSortValue,
          isPiSortOrderDropdownEnabled: isPiSortOrderDropdownEnabled,
          isBbSortOrderDropdownEnabled: isBbSortOrderDropdownEnabled,
          buttonProps: genericSecondaryTypography,
          isSplitView: isSplitView
        })]
      }), !isLessThanMd && !hideViewToggle && _jsx(Button, _objectSpread(_objectSpread(_objectSpread({
        "data-testid": "controls-map-or-list-button",
        size: "sm",
        variant: "genericSecondary",
        onClick: onChangeViewType
      }, buttonWidth), genericSecondaryTypography), {}, {
        children: _jsx(Text, _objectSpread(_objectSpread({
          as: "span"
        }, genericSecondaryTypography), {}, {
          children: viewType === VIEW_TYPE_CONSTANTS.listView ? buttonLabels.mapLong : buttonLabels.listLong
        }))
      })), !isLessThanMd && hideViewToggle && rightContent]
    })), renderSelectedDynamicFilters(!!showDynamicFilters, selectedFilters, viewType, _setSelectedFilters2, onChangeFilters, t('tableFilter.clearAll'))]
  });
}
var renderSelectedDynamicFilters = (showDynamicFilters, selectedFilters, viewType, setSelectedFilters, onChangeFilters, clearAllLabel) => {
  return _jsx(_Fragment, {
    children: showDynamicFilters && selectedFilters.length > 0 && _jsxs(Flex, _objectSpread(_objectSpread(_objectSpread({}, wrapperStyles), viewType === VIEW_TYPE_CONSTANTS.mapView ? mapViewHorizontalOffsetStyles : {}), {}, {
      overflow: "auto",
      position: "relative",
      mt: "0",
      gridColumn: "1 / -1",
      children: [_jsx(Flex, {
        mr: "0.5rem",
        flexShrink: 0,
        children: _jsx(Text, _objectSpread(_objectSpread({}, clearFiltersStyles), {}, {
          onClick: () => {
            setSelectedFilters([]);
            onChangeFilters([]);
          },
          "data-testid": 'srp-dynamic-filters-Clear-Filters-Button',
          children: clearAllLabel
        }))
      }), selectedFilters.map(filter => _createElement(Flex, _objectSpread(_objectSpread({}, filterPodStyles), {}, {
        key: filter.name,
        "data-testid": "srp-dynamic-filters-Pod-".concat(filter.name)
      }), _jsx(Text, {
        fontFamily: "body",
        children: filter.name
      }), _jsx(IconComponent, {
        svg: _jsx(Dismiss, {
          "data-testid": "srp-dynamic-filters-Pod-".concat(filter.name, "-Dismiss-Filter-Button")
        }),
        onClick: () => {
          var newList = selectedFilters.filter(selectedFilter => selectedFilter !== filter);
          setSelectedFilters(newList);
          onChangeFilters(newList.reduce((prev, curr) => {
            var _curr$codes3;
            return [...prev, ...((_curr$codes3 = curr.codes) !== null && _curr$codes3 !== void 0 ? _curr$codes3 : [])];
          }, []));
        },
        style: {
          cursor: 'pointer'
        }
      })))]
    }))
  });
};
export var getSelectedFilters = (filterByLabels, filters) => {
  var _filterByLabels$dynam;
  return ((_filterByLabels$dynam = filterByLabels === null || filterByLabels === void 0 ? void 0 : filterByLabels.dynamicFilters) !== null && _filterByLabels$dynam !== void 0 ? _filterByLabels$dynam : []).map(dynamicFilter => {
    var _dynamicFilter$groupI;
    return {
      groupItems: ((_dynamicFilter$groupI = dynamicFilter.groupItems) !== null && _dynamicFilter$groupI !== void 0 ? _dynamicFilter$groupI : []).map(groupItem => _objectSpread(_objectSpread({}, groupItem), {}, {
        operator: dynamicFilter.groupOperator
      }))
    };
  }).flatMap(dynamicFilter => {
    var _dynamicFilter$groupI2;
    return (_dynamicFilter$groupI2 = dynamicFilter.groupItems) !== null && _dynamicFilter$groupI2 !== void 0 ? _dynamicFilter$groupI2 : [];
  }).filter(filter => {
    var _filter$codes;
    var filterCodes = ((_filter$codes = filter.codes) !== null && _filter$codes !== void 0 ? _filter$codes : '').split(',');
    return filters === null || filters === void 0 ? void 0 : filters.some(selectedFilter => filterCodes.includes(selectedFilter));
  }).map(filter => {
    var _filter$codes2;
    return {
      codes: ((_filter$codes2 = filter.codes) !== null && _filter$codes2 !== void 0 ? _filter$codes2 : '').split(','),
      name: filter.label,
      operator: filter.operator,
      queryParam: filter.queryParam
    };
  });
};
var filterPodStyles = {
  p: 'var(--chakra-space-xs) var(--chakra-space-xmd)',
  borderRadius: '2.75rem',
  backgroundColor: 'rgba(229, 242, 246, 1)',
  alignItems: 'center',
  h: '1.75rem',
  minW: 'max-content',
  gap: 'sm',
  justifyContent: 'space-between',
  mt: 'xmd',
  mr: '0.5rem'
};
var clearFiltersStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '3',
  textDecoration: 'underline',
  color: 'btnSecondaryEnabled',
  marginTop: 'md',
  _hover: {
    cursor: 'pointer'
  }
};
var splitViewWrapperStyles = {
  maxW: 'full',
  m: '0',
  py: 'xlg',
  gap: 'xlg',
  alignItems: 'center'
};
var wrapperStyles = {
  m: 'var(--chakra-space-lg) auto var(--chakra-space-md)',
  maxW: {
    mobile: 'full',
    md: '45rem',
    lg: '50.5rem',
    xl: '54rem'
  },
  w: 'full',
  flexWrap: {
    mobile: 'wrap',
    md: 'nowrap'
  }
};
var horizontalOffset = {
  mobile: '1.1875rem',
  sm: 'var(--chakra-space-lg)',
  md: '2.375rem',
  lg: '1.75rem',
  xl: '4.8125rem'
};
var mapViewWrapperStyles = {
  maxW: {
    mobile: 'full',
    md: '21rem',
    lg: '25rem',
    xl: '25rem'
  },
  marginTop: {
    mobile: 'var(--chakra-space-sm)',
    sm: 'var(--chakra-space-xmd)',
    md: 'var(--chakra-space-md)'
  }
};
var mapViewHorizontalOffsetStyles = {
  ml: horizontalOffset,
  mr: 'auto',
  maxW: '100%'
};
var buttonWidth = {
  maxW: '11.5rem',
  w: 'full',
  mr: {
    mobile: 'md',
    md: '0'
  }
};
var sharedButtonPropsLayout = {
  w: '100%',
  height: '40px',
  borderRadius: '0.75rem',
  display: 'flex !important',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0',
  px: '1rem',
  '& .chakra-icon': {
    marginInlineEnd: '0 !important',
    marginInlineStart: '0 !important'
  }
};
var sharedButtonLegacyTypography = {
  fontSize: 'var(--chakra-fontSizes-md)'
};
var sharedButtonSemanticTypography = {
  textStyle: 'body-m-regular'
};
var fullWidthChild = {
  h: '100%',
  '& > *': {
    width: '100% !important',
    height: '100%'
  }
};
var getControlsGridStyles = function getControlsGridStyles(isSortVisible) {
  var isViewToggleVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    display: 'grid',
    gridTemplateColumns: getControlsGridTemplateColumns(isSortVisible, isViewToggleVisible),
    gap: 'sm',
    w: 'full',
    alignItems: 'stretch',
    mt: 'var(--chakra-space-lg)',
    mb: 'var(--chakra-space-lg)',
    mx: 'auto'
  };
};
var getControlsGridTemplateColumns = (isSortVisible, isViewToggleVisible) => {
  if (isSortVisible && isViewToggleVisible) return 'minmax(0,0.8fr) minmax(0,1.6fr) minmax(0,0.8fr)';
  if (isSortVisible) return 'minmax(0,1fr) minmax(0,1fr)';
  if (isViewToggleVisible) return 'minmax(0,1fr) minmax(0,1fr)';
  return 'minmax(0,1fr)';
};
var mapListButtonStyles = _objectSpread(_objectSpread({}, sharedButtonPropsLayout), {}, {
  h: '40px',
  variant: 'genericSecondary',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0'
});
var filterIconStyles = {
  boxSize: '1.25rem',
  position: 'relative',
  top: '2px',
  left: '1px',
  overflow: 'visible'
};
var listIconStyles = {
  boxSize: '1.125rem',
  position: 'relative',
  top: '1px'
};
var mapIconStyles = {
  width: '0.8rem',
  overflow: 'visible'
};